import type { IconData } from '@stacksjs/iconify-core'

export const governmentBuilding1: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M12.119 45s-.438-23.96.368-32.956a3.43 3.43 0 0 1 .758-1.88C16.927 5.668 22.132 3 23.872 3s7.173 2.668 10.882 7.165c.442.536.697 1.188.76 1.88c.805 8.994.367 32.955.367 32.955\"/><path d=\"M12.195 17.18q-2.028.07-3.435.14a3.68 3.68 0 0 0-3.524 3.516C5.12 23.18 5 26.767 5 31.6V45m30.805-27.82q2.028.069 3.435.141a3.68 3.68 0 0 1 3.523 3.515C42.88 23.18 43 26.767 43 31.6V45M21 12a3 3 0 1 0 6 0a3 3 0 1 0-6 0m7 33v-8.001C28 34.789 26.21 33 24 33s-4 1.79-4 3.999V45m0-26v2m0 5v2m8-9v2m0 5v2m17 17H3\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default governmentBuilding1
